// @flow
import * as React from "react";
import { Message } from "semantic-ui-react";

import i18n from "../../../i18n";

import Styles from "./NotFound.module.scss";

export const NotFoundRoute = "/fehler";

export const NotFound = () => {
  return (
    <div className={Styles.notFoundWrapper}>
      <Message negative>{i18n.t("common:error.404")}</Message>
    </div>
  );
};

export default NotFound;
